module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-swipe"
  }, [_c('div', {
    ref: "swipeEle",
    staticClass: "swipe-item swipe-wrapper",
    class: {
      slideRight: _vm.slideRight,
      slideLeft: _vm.slideLeft
    },
    on: {
      "mouseup": _vm.initEvent
    }
  }, [_vm._t("leftComponent")], 2), _vm._v(" "), _c('div', {
    staticClass: "swipe-item side-tab",
    class: {
      slideRight: _vm.slideRight
    }
  }, [_vm._t("rightComponent")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5199f490","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItemSwipe.vue
// module id = 1722
// module chunks = 180